// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gross-fee-modal {
  width: 430px;

  height: auto;
}

.gross-fee-text {
  font-size: 16px;
  font-weight: 700;
}
.gross-fee {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
}

.gross-fee-cnl-btn-txt {
  color: #000;
  font-size: 16px;
  font-weight: 400;
}
.gross-fee-cnl-btn {
  background-color: #f0f0f0 !important;
  height: 40px;
  width: 89px;
  border: none;
}
.gross-fee-cnl-btn:hover {
  background-color: #f0f0f0 !important;
  height: 40px;
  width: 89px;
}
.gross-fee-sve-btn-txt {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}
.gross-fee-sve-btn {
  background-color: #d2042d !important;
  height: 40px;
  width: 70px;
  border: none !important;
}
.gross-fee-sve-btn:hover {
  background-color: #d2042d !important;
  height: 40px;
  width: 70px;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/gross-fee-modal/GrossFee.css"],"names":[],"mappings":"AAAA;EACE,YAAY;;EAEZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb","sourcesContent":[".gross-fee-modal {\n  width: 430px;\n\n  height: auto;\n}\n\n.gross-fee-text {\n  font-size: 16px;\n  font-weight: 700;\n}\n.gross-fee {\n  margin-top: 20px;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.gross-fee-cnl-btn-txt {\n  color: #000;\n  font-size: 16px;\n  font-weight: 400;\n}\n.gross-fee-cnl-btn {\n  background-color: #f0f0f0 !important;\n  height: 40px;\n  width: 89px;\n  border: none;\n}\n.gross-fee-cnl-btn:hover {\n  background-color: #f0f0f0 !important;\n  height: 40px;\n  width: 89px;\n}\n.gross-fee-sve-btn-txt {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 400;\n}\n.gross-fee-sve-btn {\n  background-color: #d2042d !important;\n  height: 40px;\n  width: 70px;\n  border: none !important;\n}\n.gross-fee-sve-btn:hover {\n  background-color: #d2042d !important;\n  height: 40px;\n  width: 70px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
